import { render } from "./PushNotificationListComponent.vue?vue&type=template&id=1608764a&scoped=true"
import script from "./PushNotificationListComponent.vue?vue&type=script&lang=js"
export * from "./PushNotificationListComponent.vue?vue&type=script&lang=js"

import "./PushNotificationListComponent.vue?vue&type=style&index=0&id=1608764a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1608764a"],['__file',"resources/js/components/admin/pushNotification/PushNotificationListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1608764a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1608764a', __exports__)) {
    api.reload('1608764a', __exports__)
  }
  
  module.hot.accept("./PushNotificationListComponent.vue?vue&type=template&id=1608764a&scoped=true", () => {
    api.rerender('1608764a', render)
  })

}


export default __exports__